import http from '../_http'

// target : webcastle.log
const detect = {
  //default
  summaryDetect: (m) => { return http.post(`manager/webcastle/detect/summary`, m); },
  listDetect: (m) => { return http.post(`manager/webcastle/detect/list`, m); },
  detailDetect: (m) => { return http.get(`manager/webcastle/detect/${m.id}`); },

  //crud
  insertDetect: (m) => { return http.post(`manager/webcastle/detect`, m); },
  updateDetect: (m) => { return http.put(`manager/webcastle/detect/${m.id}`); },
}

export default detect

export { detect }